import React, { useRef } from "react";
import "./reel-player.scss";
import PauseIcon from "../../../../../Icons/icons/PlayerIcon/PauseIcon";
import PlayIcon from "../../../../../Icons/icons/PlayerIcon/PlayIcon";
import { formatTime } from "../../../../../../utils/global";
import MuteIcon from "../../../../../Icons/icons/PlayerIcon/MuteIcon";
import SpeakerIcon from "../../../../../Icons/icons/PlayerIcon/SpeakerIcon";

const Controls = ({
  playing,
  setPlaying,
  playedSeconds,
  duration,
  playerRef,
  setIsMutated,
  isMutated,
}) => {
  const width = (playedSeconds / duration) * 100;
  const progressRef = useRef();

  const railClick = (e) => {
    const rect = e.target.getBoundingClientRect();
    const x = e.clientX - rect.left; //x position within the element.
    const width = e.target.clientWidth;
    const completeFraction = x / width;
    playerRef?.current?.seekTo(completeFraction, "fraction");
  };

  return (
    <div className="controls-container">
      <div className="top-controls">
        <div className="left-content">
          {playing ? (
            <PauseIcon
              width={16}
              height={16}
              className="player-icons"
              onClick={() => setPlaying(false)}
            />
          ) : (
            <PlayIcon
              width={16}
              height={16}
              className="player-icons"
              onClick={() => setPlaying(true)}
            />
          )}
          <div>
            {formatTime(playedSeconds)} / {formatTime(duration)}
          </div>
        </div>
        <div>
          {isMutated ? (
            <MuteIcon
              className="player-icons"
              width={20}
              height={20}
              onClick={() => setIsMutated(false)}
            />
          ) : (
            <SpeakerIcon
              className="player-icons"
              width={21}
              height={21}
              onClick={() => setIsMutated(true)}
            />
          )}
        </div>
      </div>
      <div
        ref={progressRef}
        className="player-progress-background"
        onClick={railClick}
      >
        <div className="player-progress-dot" style={{ left: `${width}%` }} />
        <div className="player-progress" style={{ width: `${width}%` }} />
      </div>
    </div>
  );
};

export default Controls;
